// Annual counseling meeting documentation for
// clinical assistant professors and clinical associate professors

import { CCSetup } from "../../cclib/CCSetup";
import { CCStructure } from "../../cclib/CCStructure";
import { reputationSetup, reputationUpdate } from "../afcs/tables";
import { clinicalStructure } from "./structure";

import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat.js";
import { CCIcon } from "../../cclib/components/UI";
import { afcsDataPrefix } from "../afcs/afcs";
import {
  cleanUpCheckboxes,
  cleanUpContributionSection,
  copyLastYearContribValues,
  getReputationData,
  outputContribution,
  setupDeptEMForm,
  updateContributionTotals,
  watchContributionInputs
} from "../shared/util";
dayjs.extend(LocalizedFormat);

// This data prefix does not match the naming convention of the
// other sections of this career conference because this part
// used to be called "acmd" instead of "clinical" and was renamed when
// I realized "acmd" was too generic. This data prefix was not renamed
// to avoid issues with data migration.
export const clinicalDataPrefix = "stanford_em_acmd_";

import { DISABLE_EMAILS } from "../stanford_em";

function cleanUpTopics() {
  const containers = $(".confCheck[data-key*='topic_']").parent();
  containers.css("margin-bottom", "0");
}

export function addPersistentClinicalHeader(cc: CCSetup) {
  cc.addButton(
    "primary",
    CCIcon("download") + "<span>CE Annual Counseling Form</span>",
    {
      relative: "after",
      selector: ".downloadDataSummary"
    },
    "downloadCeAnnualCounseling",
    () => outputClinical(cc)
  );
}
export function updateClinical(cc: CCSetup) {
  if (cc.uninitializedYearState) {
    copyLastYearContribValues(cc);
  }
  updateContributionTotals(cc);
}
export function outputClinical(cc: CCSetup) {
  const data = cc.newDef.career[cc.viewYear].data;
  const dataOverride = {};
  cc.conferenceExport(
    "stanford_em_clinical_annual_counseling.docx",
    `Form_CE Annual_Counseling_${cc.cvOwner.name}_${dayjs(new Date()).format("MM-DD-YYYY")}`,
    {
      ...dataOverride,
      ...outputContribution(cc),
      ...getReputationData(data, afcsDataPrefix)
    },
    () => ""
  );
}
export function setupClinical(cc: CCSetup) {
  const structure = new CCStructure(clinicalStructure);
  cc.generateFieldsFromStructure(structure, cc.ccRoot, false);
  cleanUpContributionSection(cc);
  $("#contrib-container").css("margin-bottom", "10px");
  updateContributionTotals(cc);
  watchContributionInputs(cc);
  cleanUpCheckboxes();
  cleanUpTopics();

  cc.defineCustomSection("custom-reputation", reputationSetup, (table, cc) =>
    reputationUpdate(table, cc, "mentor")
  );

  setupDeptEMForm(cc, "CE");

  updateContributionTotals(cc);
  cc.appendStatusButtons(false, DISABLE_EMAILS);
  cc.update(cc.struct.structure);
  cc.contextMethods.updateLayout();
}
